
import {throwError,  Observable } from 'rxjs';
import {map, catchError} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { UtilitiesModel, UtilitiesGroupUtilityModel } from 'app/models/utilities.model';
import { ConfigService } from './config.service';
import { UtilityServiceSearchModel } from 'app/signup/models/signup-service.model';
import { ProviderDetailsModel } from 'app/components/utilities/utilities.component';

@Injectable()
export class UtilitiesService {

    constructor(private http: HttpClient, private config: ConfigService) {

    }

    public GetUtilities(): Observable<UtilitiesModel> {
        return this.http.get<UtilitiesModel>(this.config.getApiRoute('api/v3/customer-portal/utilities')).pipe(
            map(data => {
                return data;
            }),
            catchError((err: HttpErrorResponse)  => {
                return throwError(err.error.message);
            }),);

    }

    public PutLinkUtility(argument: UtilitiesGroupUtilityModel): Observable<UtilitiesModel> {
        return this.http.put<UtilitiesModel>(this.config.getApiRoute('api/v3/customer-portal/utilities/' + argument.id), argument).pipe(
            map(data => {
                return data;
            }),
            catchError((err: HttpErrorResponse)  => {
                return throwError(err.error.message);
            }),);

    }

    public GetUtilityServicesSearch(): Observable<Array<UtilityServiceSearchModel>> {
        return this.http.get<Array<UtilityServiceSearchModel>>(this.config.getApiRoute('api/v3/customer-portal/utilities/category-list')).pipe(
            map(data => {
                return data;
            }),
            catchError((err: HttpErrorResponse)  => {
                return throwError(err.error.message);
            }),);

    }

    public PutAddUtility(argument: ProviderDetailsModel): Observable<UtilitiesModel> {
        return this.http.put<UtilitiesModel>(this.config.getApiRoute('api/v3/customer-portal/utilities/add-utility'), argument).pipe(
            map(data => {
                return data;
            }),
            catchError((err: HttpErrorResponse)  => {
                return throwError(err.error.message);
            }),);

    }

    public GetProviderDetails(provider_id:string): Observable<ProviderDetailsModel> {
        return this.http.get<ProviderDetailsModel>(this.config.getApiRoute('api/v3/customer-portal/utilities/provider-details/'+provider_id)).pipe(
            map(data => {
                return data;
            }),
            catchError((err: HttpErrorResponse)  => {
                return throwError(err.error.message);
            }),);

    }
}
